.card__link {
  margin: 0;
  padding: 0;
  list-style: none;
  box-sizing: border-box;
  position: relative;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  width: 160px;
  min-height: 160px;
  height: 100%;
  text-align: center;
  text-decoration: none;
  color: #333333;
  border: 1px solid #ededed;
  outline: 0;
  background-color: #ffffff;
}

.card__link *,
.card__link *::before,
.card__link *::after {
  box-sizing: inherit;
}

@media screen and (max-width: 979px) {
  .card__link {
    padding: 16px 12px;
  }

  .card__link--size-extra-points-1 {
    min-height: 174px;
  }

  .card__link--size-extra-points-2 {
    min-height: 188px;
  }

  .card__link--size-extra-points-3 {
    min-height: 202px;
  }

  .card__link--size-extra-points-4 {
    min-height: 216px;
  }
}

@media screen and (min-width: 980px) {
  .card__link {
    width: 100%;
    height: 280px;
    padding: 24px;
  }

  .card__link::before {
    position: absolute;
    z-index: 1;
    bottom: 0;
    display: block;
    width: 100%;
    height: 40px;
    content: "";
    background: linear-gradient(0deg, #fff, rgba(255, 255, 255, 0));
  }

  :host(:not([dir="rtl"])) .card__link::before {
    left: 0;
  }

  :host([dir="rtl"]) .card__link::before {
    right: 0;
  }

  .card__link:hover {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
}

@media screen and (min-width: 980px) {
  .card__link-text-content {
    flex: 1 0 auto;
  }
}

.card__title {
  overflow: hidden;
  margin: 0;
  text-overflow: ellipsis;
}

.card__title .highlight-naming {
  font-weight: 400;
}

.card__title .highlight-naming .accent {
  font-weight: 700;
}

@media screen and (max-width: 979px) {
  .card__title {
    font-size: 12px;
    line-height: 16px;
    max-height: 32px;
    margin-bottom: 4px;
  }
}

@media screen and (min-width: 980px) {
  .card__title {
    font-size: 16px;
    font-weight: bold;
    line-height: 26px;
    max-height: 52px;
    margin-bottom: 8px;
  }
}

.card__label {
  color: #9fa0a4;
}

@media screen and (max-width: 979px) {
  .card__label {
    font-size: 10px;
    line-height: 12px;
    margin: 4px 0;
  }
}

@media screen and (min-width: 980px) {
  .card__label {
    font-size: 12px;
    line-height: 18px;
    margin: 8px 0;
  }
}

.card__text-wrapper {
  justify-content: center;
  display: flex;
  min-width: 0;
}

.card__description {
  display: none;
}

@media screen and (min-width: 980px) {
  .card__description {
    display: block;
    max-height: 0;
    font-size: 14px;
    line-height: 22px;
    transition: max-height 0.3s cubic-bezier(0.33, 0.66, 0.66, 1);
    overflow: hidden;
  }

  .card__description .highlight-naming {
    font-weight: 400;
  }

  .card__description .highlight-naming .accent {
    font-weight: 700;
  }
}

@media screen and (min-width: 980px) {
  .card__link:hover .card__description {
    max-height: 150px;
  }
}

.card__picture {
  position: relative;
  margin: 16px auto 0;
}

@media screen and (max-width: 979px) {
  .card__picture {
    width: 60px;
    height: 60px;
  }
}

@media screen and (min-width: 980px) {
  .card__picture {
    width: 140px;
    height: 140px;
    background-color: #ffffff;
  }
}

@media screen and (min-width: 980px) {
  .card__picture--animate {
    flex: 0 0 auto;
    transition: transform 0.3s cubic-bezier(0.33, 0.66, 0.66, 1);
  }
}

@media screen and (min-width: 980px) {
  .card__link:hover .card__picture--animate {
    transform: translateY(8px);
  }
}

.card__additional-info {
  position: absolute;
  z-index: 1;
  display: flex;
  flex-direction: column;
}

@media screen and (min-width: 980px) {
  .card__additional-info {
    bottom: 20px;
    left: 20px;
    right: 20px;
  }
}

.card__additional-info-item + .card__additional-info-item {
  margin-top: 8px;
}

@media screen and (max-width: 979px) {
  .card__additional-info-item + .card__additional-info-item {
    margin-top: 4px;
  }
}

.card__badge {
  max-width: 156px;
}

:host(:not([dir="rtl"])) .card__badge {
  text-align: left;
}

:host([dir="rtl"]) .card__badge {
  text-align: right;
}

@media screen and (max-width: 979px) {
  .card__brand-image {
    width: 40px;
  }
}

@media screen and (min-width: 980px) {
  .card__brand-image {
    width: 60px;
    height: 100%;
  }
}

.card__brand-image--small-mobile {
  display: none;
}

:host(.mobile-gallery-slide) {
  max-width: 160px;
}

:host(.mobile-gallery-slide) .card__link:not(.server_render) {
  width: 160px;
}

:host(.mobile-gallery-slide) .card__additional-info {
  max-width: 136px;
}

@media screen and (max-width: 979px) {
  :host(.mobile-gallery-slide) .card__additional-info {
    position: absolute;
    bottom: 8px;
  }

  :host(:not([dir="rtl"]).mobile-gallery-slide) .card__additional-info {
    left: 8px;
  }

  :host([dir="rtl"].mobile-gallery-slide) .card__additional-info {
    right: 8px;
  }
}

:host(.card--small) {
  max-width: 212px;
  height: auto;
}

:host(.card--small) .card__link {
  flex-flow: row-reverse;
  justify-content: flex-end;
  width: 212px;
  height: 100%;
  min-height: 0;
  padding: 12px;
}

:host(:not([dir="rtl"]).card--small) .card__link {
  text-align: left;
}

:host([dir="rtl"].card--small) .card__link {
  text-align: right;
}

:host(.card--small) .card__title {
  font-size: 12px;
  line-height: 16px;
  max-height: 32px;
}

:host(.card--small) .card__text-wrapper {
  justify-content: flex-start;
}

:host(.card--small) .card__text {
  margin-top: 4px;
  max-width: 120px;
  justify-content: flex-start;
}

:host(.card--small) .card__picture {
  min-width: 40px;
  max-width: 40px;
  height: 40px;
}

:host(:not([dir="rtl"]).card--small) .card__picture {
  margin: 0 8px 0 0;
}

:host([dir="rtl"].card--small) .card__picture {
  margin: 0 0 0 8px;
}

@media screen and (max-width: 979px) {
  :host(.card--small) .card__link-text-content {
    position: relative;
  }
}

:host(.card--small) .card__additional-info {
  max-width: 100%;
}

@media screen and (max-width: 979px) {
  :host(.card--small) .card__additional-info {
    position: static;
  }
}

:host(.card--small) .card__brand-image {
  position: absolute;
  bottom: 0;
}

:host(:not([dir="rtl"]).card--small) .card__brand-image {
  left: 0;
}

:host([dir="rtl"].card--small) .card__brand-image {
  right: 0;
}

@media screen and (max-width: 979px) {
  :host(.card--small) .card__brand-image--small-mobile {
    display: block;
    position: absolute;
    bottom: 8px;
  }

  :host(:not([dir="rtl"]).card--small) .card__brand-image--small-mobile {
    left: 8px;
  }

  :host([dir="rtl"].card--small) .card__brand-image--small-mobile {
    right: 8px;
  }
}

@media screen and (max-width: 979px) {
  :host(.card--small) .card__brand-image--small-mobile-hidden {
    display: none;
  }
}

@media screen and (min-width: 980px) {
  :host(.card--large) .card__link {
    position: relative;
    flex-direction: row;
    height: 280px;
    padding: 40px;
  }

  :host(:not([dir="rtl"]).card--large) .card__link {
    text-align: left;
  }

  :host([dir="rtl"].card--large) .card__link {
    text-align: right;
  }

  :host(.card--large) .card__link:hover .card__description {
    max-height: 90px;
  }

  :host(.card--large) .card__text-wrapper {
    justify-content: flex-start;
  }

  :host(.card--large) .card__link-text-content {
    flex: 0 1 auto;
    order: 2;
  }

  :host(:not([dir="rtl"]).card--large) .card__link-text-content {
    padding-left: 36px;
  }

  :host([dir="rtl"].card--large) .card__link-text-content {
    padding-right: 36px;
  }

  :host(.card--large) .card__title {
    font-size: 24px;
    line-height: 30px;
    max-height: 60px;
    max-width: 338px;
    margin-top: 20px;
  }

  :host(.card--large) .card__description {
    max-height: 90px;
  }

  :host(.card--large) .card__picture {
    order: 1;
    margin: 0;
    flex: 1 0 auto;
    width: 200px;
    height: 200px;
  }

  :host([dir="rtl"].card--large) .card__picture {
      flex: 0 0 auto;
  }

  :host(.card--large) .card__label {
    margin: 12px 0;
  }
}